
export const makeVueKey = JSON.stringify

export const makeUrl = (path, base = window.$app.SERVER_URL) => path && (path.indexOf('//') === -1) ?
  [
    base.endsWith('/') ? base.substr(0, base.length - 1) : base,
    path.startsWith('/') ? path.substr(1) : path
  ].join('/') : path

export const isServerAssetPath = url => url && url.startsWith('/upload')

export const makeImage = url  => url ? makeUrl(url) : require('../assets/images/placeholder.png')

export const getImagePlaceholder = () => require('../assets/images/placeholder.png')
